import { AudioManager, Track } from "../AudioManager";
import { CreateSpineResources, Geometry, HorizontalAlign, Log, LogGroup, Point, Rect, Safe, Size, VerticalAlign } from "../MyHelpers";
import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager } from "../ResourceManager/ResourceManager";
import { SpriteResource } from "../ResourceManager/SpriteResource";
import { SlotFeaturePIXI } from "./SlotFeature";
import { ReelSetMapper, ReelSetMapperOverlay } from "./SpinAnimation/ReelSetMapper";
import { CanvasSprite } from "./Sprite/CanvasSprite";
//import { IFeatureConfiguration } from "./Bonus/BigSymbolFreegames/BigSymbolFreegamesConfig";
import { ISkeletonData, Spine } from "pixi-spine";
import * as PIXI from "pixi.js";
import { ExpandingWildBulkResult, PlayWindow } from "../api";
import { IInterval } from "../Context/Interval";
import { ISystemContext } from "../Context/SystemContext";
import { ITimeout } from "../Context/Timeout";
import { AtlasResource } from "../ResourceManager/AtlasResource";
import { JSONResource } from "../ResourceManager/JSONResource";
import { Settings } from "../Settings";
import { ExpandingWildBulkOnShowCallback, ExpandingWildPosition, ExpandingWildsBulkConfig, ExpandingWildsBulkFinishedCallback, ExpandingWildsBulkNextWildCallback, ExpandingWildsBulkParam, WildDisplayDirection } from "./ExpandingWildBulk";
import { SlotSymbol } from "./SlotSymbol";
import { SymbolTypeAnim } from "./SpineSymbols/SymbolsCollection";

interface ExpandingWildBulkParamPIXIAPP
{
	readonly wildIndex: number;
	readonly logGroup: LogGroup;
	readonly expandingWildSymbolIndex: number;
	readonly sprite: CanvasSprite;
	readonly symbolsRect: Rect;
	readonly reelSetMapper: ReelSetMapper;

	readonly systemContext: ISystemContext;	
	readonly textureSprites : PIXI.Texture [];
	readonly textureSpine : ISkeletonData;

}

export class ExpandingWildBulkPIXIAPP
{
	// size and position of this expanding wild
	//private rect: PixelRect = null;

	// size of the wild, in symbol unites
	public symbolsRect: Rect = null;

	// position of the original wild, that triggered expanding wild
	protected symbolsCenter: Point = null;

	private wildIndex: number
	protected logGroup: LogGroup;
	private expandingWildSymbolIndex: number;

	private reelSetMapper: ReelSetMapper = null;
    //private reelSetMapper2: ReelSetMapper = null;
    //private reelSetMapper3: ReelSetMapper = null;

	//private sprite: CanvasSprite = null;

	protected systemContext: ISystemContext = null;
	protected firstSymbolDelay: ITimeout = null;
	protected nextSymbolDelay: IInterval = null;
	protected spine : Spine = null;

	protected animatedSprite : PIXI.AnimatedSprite = null;
	protected containerPIXI : PIXI.Container = null;
	readonly textureSprites : PIXI.Texture [];
	readonly textureSpine : ISkeletonData;
	constructor(param: ExpandingWildBulkParamPIXIAPP) {
		this.textureSprites = param.textureSprites;
		this.textureSpine = param.textureSpine;
		//wildIndex: number, logGroup: LogGroup, expandingWildSymbolIndex: number, sprite: CanvasSprite, symbolsRect: PixelRect, reelSetMapper: ReelSetMapper) {
		this.wildIndex = param.wildIndex;
		this.logGroup = param.logGroup.Add("ExpandingWildBulk");
		this.expandingWildSymbolIndex = param.expandingWildSymbolIndex;
		//this.sprite = param.sprite;
		this.symbolsRect = param.symbolsRect;
		this.reelSetMapper = param.reelSetMapper;
		//this.reelSetMapper2 = param.reelSetMapper;
		//this.reelSetMapper3 = param.reelSetMapper;

		this.systemContext = param.systemContext.CreateSubContext(`wild-${this.wildIndex}`);

		
		//this.sprite.View().style.position = "absolute";
		//this.sprite.View().style.visibility = "hidden"; // default hidden

		this.firstSymbolDelay = this.systemContext.TimingContext().CreateTimeout("firstSymbolDelay", 250, () => {
			this.nextSymbolDelay.Start();
		});

		this.nextSymbolDelay = this.systemContext.TimingContext().CreateInterval("nextSymbolDelay", 185, () => {
			this.DisplayNext();
		});		
	}

	public SetRect(symbolsRect: Rect, symbolsCenter: Point, pixelsRect: Rect): void {
		this.symbolsRect = symbolsRect;
		this.symbolsCenter = symbolsCenter;

		//this.sprite.SetSize(pixelsRect.Size());
		//this.sprite.View().style.left = pixelsRect.x + "px";
		//this.sprite.View().style.top = pixelsRect.y + "px";
		if(this.animatedSprite != null){
			this.animatedSprite.width = pixelsRect.width;
			this.animatedSprite.height = pixelsRect.height;
		}
		//this.animatedSprite.position.set(pixelsRect.x,pixelsRect.y);

		if (this.spine != null) {
			this.spine.width = pixelsRect.width;
			this.spine.height = pixelsRect.height;
		}
		
		//this.spine.position.set(pixelsRect.x,pixelsRect.y);	

		this.containerPIXI.position.set(pixelsRect.x,pixelsRect.y);	
	}

	public View(): HTMLElement {
		return null;
	}
	public ViewPIXIAPP(): PIXI.Container{
		return this.containerPIXI;
	}

	protected currentDirection: WildDisplayDirection = WildDisplayDirection.Right;
	protected currentWild: Rect = new Rect(0, 0, 1, 1);
	//protected displayTimer: number = -1;
	//protected displayTimerDelay: number = -1;
	protected wildsDisplayed: number = 0;
	protected symbolsToDisplay: number = 0;

	protected DisplayNext(): void 
	{
		// display current wild
		this.reelSetMapper.AddOverlay(new ReelSetMapperOverlay(this.currentWild, this.expandingWildSymbolIndex));

		// Log.Debug(this.logGroup, "SEQUENTIAL WILDS - Displaying wild " + this.wildIndex + " - " + this.wildsDisplayed + " position: " + this.currentWild.x + ","+this.currentWild.y);

		// keep count how many we showed
		this.wildsDisplayed++;

		if (this.wildsDisplayed >= this.symbolsToDisplay)
		{
			this.nextSymbolDelay.Stop()
		}
		else
		{
			// advance to next one
			do
			{
				let newx: number = this.currentWild.x;
				let newy: number = this.currentWild.y;

				switch (this.currentDirection)
				{
					case WildDisplayDirection.Right:
						newx++;

						// if we reached right most symbol, go next symbol down
						if (newx +1 >= this.symbolsRect.x + this.symbolsRect.width)
						{
							this.currentDirection = WildDisplayDirection.Down;
						}

						break;

					case WildDisplayDirection.Down:
						newy++;

						// if we reached bottom most symbol, go next symbol left
						if (newy +1 >= this.symbolsRect.y + this.symbolsRect.height)
						{
							this.currentDirection = WildDisplayDirection.Left;
						}

						break;

					case WildDisplayDirection.Left:
						newx--;

						// if we reached left most symbol, go next symbol up
						if (newx  <= this.symbolsRect.x)
						{
							this.currentDirection = WildDisplayDirection.Up;
						}

						break;

					case WildDisplayDirection.Up:
						newy--;

						// if we reached top most symbol, go next symbol right
						if (newy  <= this.symbolsRect.y)
						{
							this.currentDirection = WildDisplayDirection.Right;
						}

						break;
				}

				this.currentWild = this.currentWild.SetPosition(newx, newy);

			}
			// skip center one (can happen only in 3x2, 2x3, 2x2, but not in 3x3)
			while (this.currentWild.x == this.symbolsCenter.x && this.currentWild.y == this.symbolsCenter.y);
		}
	}

	public Show(): void {

		// TODO zoom in wild
		//this.sprite.View().style.visibility = "visible";
		//this.sprite.Restart();
		if (this.animatedSprite != null) {
			this.animatedSprite.play();
			this.animatedSprite.visible = true;
		}
		if(this.spine != null){
			this.spine.visible = true;
			this.spine.state.setAnimation(0,"winSymbol",false);
		}

		//lets always start from left to right in top line
		this.currentDirection = WildDisplayDirection.Right;

		// display first wild right away
		this.wildsDisplayed = 0;
		this.currentWild = this.currentWild.SetPosition(this.symbolsRect.x, this.symbolsRect.y);

		// top left corner starts with original wild, skip it right away
		if (this.currentWild.x == this.symbolsCenter.x &&
			this.currentWild.y == this.symbolsCenter.y)
		{
			this.currentWild = this.currentWild.Move(1, 0);
			this.currentDirection = WildDisplayDirection.Down;
		}

		//this.DisplayNext();

		// did we display all symbols?
		// 3x3 = 9 - center symbol = 8
		// 2x3 = 6 - center symbol = 5
		// 2x2 = 4 - center symbol = 3
		this.symbolsToDisplay = this.symbolsRect.width * this.symbolsRect.height -1;

		// display next wilds in regular interval
		this.firstSymbolDelay.Start();

		this.OnShow();
	}

	public Hide(): void {
		
		// apply on hide to prevent loosing wilds
		this.Apply();

		//this.sprite.View().style.visibility = "hidden";
		//this.sprite.Stop();
		if (this.animatedSprite != null) {
			this.animatedSprite.visible = false; 		
			this.animatedSprite.stop();
		}
		if (this.spine != null) {
			this.spine.visible = false;
			this.spine.state?.clearTracks();
		}	
		this.firstSymbolDelay.Stop();
		this.nextSymbolDelay.Stop();
	}

	public Update(): void {
		//this.sprite.Update();
	}

	public Apply(): void
	{
		this.reelSetMapper.AddOverlay(new ReelSetMapperOverlay(this.symbolsRect, this.expandingWildSymbolIndex));
	}


	private onShowCallbacks: ExpandingWildBulkOnShowCallback[] = [];
	public AddOnShowCallback(callback: ExpandingWildBulkOnShowCallback) {
		this.onShowCallbacks.push(callback);
	}

	private OnShow() {
		for (let i = 0 ; i < this.onShowCallbacks.length; i++) {
			this.onShowCallbacks[i](this.wildIndex);
		}
	}

	public Create() {
		this.containerPIXI = new PIXI.Container();
		if (this.textureSprites.length > 0) {
			this.animatedSprite = new PIXI.AnimatedSprite(this.textureSprites);
			this.animatedSprite.animationSpeed = 0.5;
			this.animatedSprite.visible = false;
			this.containerPIXI.addChild(this.animatedSprite)
		}

		if (this.textureSpine != null) {
			this.spine = new Spine(this.textureSpine);
			this.spine.visible = false;
			this.containerPIXI.addChild(this.spine);
		}
	}

	public Destroy(){
		Safe(()=>{ this.animatedSprite?.destroy(false)});
		Safe(()=>{this.containerPIXI?.destroy(true)});
		Safe(()=>{this.spine?.destroy(true)});
	}
}

export class ExpandingWildsBulkPIXIAPP extends SlotFeaturePIXI
{
	public override CreatePIXIAPP(){
		//throw new Error("Method not implemented.");
		this.viewPIXIAPP = new PIXI.Container();
		this.viewPIXIAPP.name = "ExpandingWildsBulkPIXIAPP";
		this.viewPIXIAPP.width = Settings.ScreenWidth;
		this.viewPIXIAPP.height = Settings.ScreenHeight;
		//this.viewPIXIAPP.y = Settings.ScreenHeight * (Settings.Screens - 1);
	}
	protected params: ExpandingWildsBulkParam = null;
	// size of slot window, in pixels
	private slotWindow: Rect = null;

	// size of slot window, in symbols
	private slotWindowSymbolSize: PlayWindow = null;

	// size of single symbol, in pixels
	private symbolSize: Size = null;

	//private sprite: Sprite = null;
	//private canvas: MyCanvas = null;
	//private view: HTMLElement = null;

	private currentWild: number = -1;
	//private timer: number = 0;

	//private logGroup: string = "ExpandingWildsBulk";

	private reelSetMapper: ReelSetMapper = null;


    private symbol: SlotSymbol = null;
	private audio: AudioManager = null;
	private systemContext: ISystemContext;
	private nextWildDelay: IInterval;

	protected viewPIXIAPP : PIXI.Container = null;
	protected animatedSprite : PIXI.AnimatedSprite = null;
	//protected expandingWildTexture: PIXI.Texture[] = [];

	public constructor(param: ExpandingWildsBulkParam, config: ExpandingWildsBulkConfig)
	{
		super(param.logGroup, param.resid, "ExpandingWildsBulk", param.resourcesBasePath);

		this.params = param;
		this.symbol = param.availableSymbols.find(s => s.ID == config.Symbol);
		
        if (!this.symbol)
		    throw `No required symbol ${config.Symbol}`;
		
		this.slotWindow = param.slotWindow;
		this.slotWindowSymbolSize = param.slotWindowSymbolSize;
		this.reelSetMapper = param.reelSetMapper;

		if (this.reelSetMapper == null) {
			Log.Error(this.logGroup, "ReelSetMapper should not be null");
			debugger;
		}

		this.symbolSize = new Size(this.slotWindow.width / this.slotWindowSymbolSize.Width, this.slotWindow.height / this.slotWindowSymbolSize.Height);

		this.audio = param.audio;

		// this.viewPIXIAPP = new PIXI.Container();
		// this.viewPIXIAPP.name = "ExpandingWildsBulkPIXIAPP";
		// this.viewPIXIAPP.width = Settings.ScreenWidth;
		// this.viewPIXIAPP.height = Settings.ScreenHeight;
		// this.viewPIXIAPP.y = Settings.ScreenHeight * (Settings.Screens - 1)	

		this.systemContext = param.systemContext.CreateSubContext("ExpandingWildsBulk");

		this.nextWildDelay = this.systemContext.TimingContext().CreateInterval("nextWildDelay", 4000, () => {
			this.NextWild();
		});

		if(param.symbolTypeAnim == SymbolTypeAnim.Spine) this.nextWildDelay = this.systemContext.TimingContext().CreateInterval("nextWildDelay", 2000, () => {
			this.NextWild();
		});
	}

	public wilds: ExpandingWildBulkPIXIAPP[] = [];
	private lastResult: ExpandingWildBulkResult = null;

	public async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {		
		this.PrepareResourcesSpine(resourceManager);
		this.PrepareResourcesSprite(resourceManager);
		// load sound
		this.audio.AddTrack(new Track(this.resourcesBasePath + "background" + Settings.audioFormat, this.resid.ScopedResourceName("background")));		
	}

	protected PrepareResourcesSpine(resourceManager : IWriteOnlyResourceManager) {
		if(this.params.symbolTypeAnim == SymbolTypeAnim.Sprites) return;
		resourceManager.Add(new JSONResource(this.resourcesBasePath + "Spine/expanding_wild_bulk.json", this.resid.ScopedResourceName("Feature-ExpandingWildBulk-JSON")));
		resourceManager.Add(new AtlasResource(this.resourcesBasePath + "Spine/expanding_wild_bulk.atlas", this.resid.ScopedResourceName("Feature-ExpandingWildBulk-ATLAS")));
	}

	protected PrepareResourcesSprite(resourceManager : IWriteOnlyResourceManager) {
		// load sprite
		if(this.params.symbolTypeAnim == SymbolTypeAnim.Spine) return;
		resourceManager.AddGlobal(new SpriteResource(this.resourcesBasePath + "expanding_wild_bulk", ResourceIdentifier.Global.Add(this.params.gameName).Add("Feature").Add("ExpandingWildBulk"), true, this.logGroup.Add("ExpandingWildBulk"), true));		
	}

	public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		await this.ResourcesLoadedSymbolSpine(resourceManager);
		//await this.ResourcesLoadedSymbolSpine(resourceManager);
		await this.ResourcesLoadedSymbolSprite(resourceManager);
		

	}

	protected symbolRecTexture : Rect = null;
	protected pixiAssetSymbolExpandingWild : ISkeletonData  
	protected async ResourcesLoadedSymbolSpine(resourceManager: IReadOnlyResourceManager) {
		if(this.params.symbolTypeAnim == SymbolTypeAnim.Sprites) return;
		let symbolJsonResource = resourceManager.Get<JSONResource>(this.resid.ScopedResourceName("Feature-ExpandingWildBulk-JSON"));
		let pixiAssetSymbol = await PIXI.Assets.load(symbolJsonResource.path);
		this.pixiAssetSymbolExpandingWild = pixiAssetSymbol.spineData;
		let spine = await CreateSpineResources(pixiAssetSymbol.spineData);
		//spine.destroy();0'p;ojli8kjhtgr7 efn6svfbacwxAergszwececasd
		this.symbolRecTexture = new Rect(spine.x,spine.y,spine.width,spine.height);
	}

	protected expandingWildTexture : PIXI.Texture [] = [];
	protected async ResourcesLoadedSymbolSprite (resourceManager : IReadOnlyResourceManager){
		if(this.params.symbolTypeAnim == SymbolTypeAnim.Spine) return;
		let sprite = resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add(this.params.gameName).Add("Feature").Add("ExpandingWildBulk")).sprite;
		//let expandingWildTexture : PIXI.Texture [] = []
;		//this.sprite = resourceManager.Get<SpriteResource>(this.resid.Add("itemsprite")).sprite;
		for (let decodedFrame of sprite.shared.decodedFrames) {
			//console.log(`Symbol_FrameDecode ${s.ID}`, decodedFrames);

			//console.log(`Symbol_FrameDecode ${s.ID}`, decodedFrames);
			//baseTexture.scaleMode;
			//let scaleWidth = this.params.spinnableReels.GetSymbolSize().width / baseTexture.width;
			//let scaleHeight = this.params.spinnableReels.GetSymbolSize().height / baseTexture.height
			//let scale = Math.min(scaleWidth, scaleHeight);
			//baseTexture.width = baseTexture.width * scale;
			//baseTexture.height = baseTexture.height * scale
			// baseTexture.width = this.spinnableReels.GetSymbolSize().width;
			// baseTexture.height = this.spinnableReels.GetSymbolSize().height;
			let symbolTexture = PIXI.Texture.from(decodedFrame);


			this.expandingWildTexture.push(symbolTexture);
		};


		this.animatedSprite = new PIXI.AnimatedSprite(this.expandingWildTexture);
		//this.animatedSprite.width = this.symbolsRect.width;
		//this.animatedSprite.height = this.symbolsRect.height;
		this.animatedSprite.visible = false;
		this.animatedSprite.animationSpeed = 0.5; 			
		this.symbolRecTexture = new Rect(this.animatedSprite.x,this.animatedSprite.y,this.animatedSprite.width,this.animatedSprite.height);		
	}

	public Prepare(featureResult: any): void
	{

		//this.wilds = [];
		let result: ExpandingWildBulkResult = featureResult as ExpandingWildBulkResult;
		this.lastResult = result;

		// create additional wilds
		if (this.wilds.length < result.Positions.length)
		{
			for (let i = this.wilds.length; i < result.Positions.length; i++) {


				//let sprite: CanvasSprite = new CanvasSprite({sprite: this.sprite.Copy(), canvasSize: new Size(1, 1)});

				let param: ExpandingWildBulkParamPIXIAPP = {
                    wildIndex: i, 
                    logGroup: this.logGroup,
                    expandingWildSymbolIndex: this.symbol.Index,
                    sprite: null, 
                    symbolsRect: new Rect(0, 0, 1, 1),
                    reelSetMapper: this.reelSetMapper,
					systemContext: this.systemContext,				
					textureSprites : this.expandingWildTexture,
					textureSpine : this.pixiAssetSymbolExpandingWild
                };
				
				let wild: ExpandingWildBulkPIXIAPP = new ExpandingWildBulkPIXIAPP(param);
				//wild.View().style.zIndex=ZIndex.WildBulk.toString();
				wild.AddOnShowCallback((wildIndex: number) => this.OnWildShown(wildIndex));

				this.wilds.push(wild);
				//this.view.appendChild(wild.View());

				//this.viewPIXIAPP.addChild(wild.ViewPIXIAPP());
				//wild = null;
			}
		}//

		// wild expands to all neighbours
		for (let i = 0; i < result.Positions.length; i++) {
			let position: ExpandingWildPosition = result.Positions[i];

			let leftReel = Math.max(position.reel -1, 0);
	        let rightReel = Math.min(position.reel + 1, this.slotWindowSymbolSize.Width - 1);

	        
	        let topSymbol = Math.max(position.row - 1, 0);
	        let bottomSymbol = Math.min(position.row + 1, this.slotWindowSymbolSize.Height - 1);

			// include right and bottom symbols, they are covered
			let wildSymbolsRect = Rect.FromCoordiantes(leftReel, topSymbol, rightReel +1, bottomSymbol +1);		

			// calculate actual size, so that image covers the symbols that will change

			// remember center, wild zooms in from the center symbol, that triggered
			let centerSymbol = new Point(position.reel, position.row);
			// center, in pixels
			
			//let center = new Point((centerSymbol.x + 0.5) * this.symbolSize.width, (centerSymbol.y + 0.5) * this.symbolSize.height);



			let wild: ExpandingWildBulkPIXIAPP = this.wilds[i];
			wild.Create();
			this.viewPIXIAPP.addChild(wild.ViewPIXIAPP());
			// calculate size of canvas, so that it covers whole area 
			let wildContainRect: Rect = new Rect(
				(position.reel * this.symbolSize.Width) + this.slotWindow.x - (this.symbolSize.Width /4),
				(position.row * this.symbolSize.Height) + this.slotWindow.y - (this.symbolSize.Height /4),

				1 * this.symbolSize.Width + (this.symbolSize.Width /2),
				1 * this.symbolSize.Height + (this.symbolSize.Height/2)
			);
			let wildCoverRect = Geometry.CoverRect(this.symbolRecTexture, wildContainRect, HorizontalAlign.Center, VerticalAlign.Center);
			let wildCoverInflatedRect = this.InflateWildSize(wildCoverRect);

			// avoid to go to second screen
			wildCoverInflatedRect = wildCoverInflatedRect.SetPosition(wildCoverInflatedRect.x, Math.max(wildCoverInflatedRect.y,0));
			
			// set new position and size of the wild
			wild.SetRect(wildSymbolsRect, centerSymbol, wildCoverInflatedRect);
		}
	}

	protected started: boolean = false;
	protected stopRequested: boolean = false;

	public get IsRunning(): boolean
	{
		return this.started;
	}

	public Start(): void 
	{
		this.started = true;
		this.stopRequested = false;

		this.currentWild = -1;
		this.nextWildDelay.Start();
		
		// start first wild right now
		this.NextWild();
	}

	public RequestStop(): void
	{
		if (this.started)
		{
			if (!this.stopRequested)
			{
				Log.Error(this.logGroup, "Requesting stop!");

				this.stopRequested = true;
				// stop timer if running
				this.nextWildDelay.Stop();

				//this.sprite.Restart(false);
				//this.animatedSprite.play();

				// hide current wild
				if (this.currentWild != -1) 
				{
					this.wilds[this.currentWild].Hide(); // hide will also apply
					//this.wilds[this.currentWild].Apply();

					// make sure to redraw sprites
					this.wilds[this.currentWild].Update();
				}

				// go fast trough remaining wilds
				for (this.currentWild++; this.currentWild <this.lastResult.Positions.length; this.currentWild++)
				{
					// only apply wild without showing it
					this.wilds[this.currentWild].Apply();

					this.wilds[this.currentWild].Update();

					// move to next
					this.OnNext(this.currentWild, this.wilds[this.currentWild].symbolsRect);
				}

				this.StopAudio();

				// reset current wild
				this.currentWild = -1;

				this.started = false;
				this.stopRequested = false;

				this.OnComplete();
			}
			else
			{
				Log.Error(this.logGroup, "Stop already requested!");
			}
		}
		else
		{
			Log.Error(this.logGroup, "Feature not started!");
		}
	}

	protected InflateWildSize(wildRect: Rect): Rect{

		return wildRect.Inflate(new Size(wildRect.width * 0.1, wildRect.height * 0.1));
	}

	private OnWildShown(wildIndex: number) {
		//this.sprite.Restart(false);
		//this.animatedSprite.play();
	}

	private NextWild(): void {

		if (this.currentWild >= this.lastResult.Positions.length -1) {

			// hide the last
			if (this.currentWild != -1) {
				this.wilds[this.currentWild].Hide();
			}
			
			// finished
			// Log.Debug(this.logGroup, "Wilds complete, shown " + this.lastResult.Positions.length + " wilds");

			this.nextWildDelay.Stop();
			this.started = false;
			this.stopRequested = false;
			this.OnComplete();
		}
		else {

			if (this.currentWild != -1) {
				// hide current wild
				this.wilds[this.currentWild].Hide();
			}

			this.currentWild++;

			// Log.Debug(this.logGroup, "Displaying wild " + this.currentWild + " of " + this.lastResult.Positions.length);

			this.audio.Play(this.resid.ScopedResourceName("background") , false);
			this.wilds[this.currentWild].Show();

			// play audio - repeat up to 3 times depending on wild size
			let wildArea: number = this.wilds[this.currentWild].symbolsRect.Area();
			let repeats: number = 1;
			if (wildArea == 4) {
				// one time
			}
			else if (wildArea == 6) {
				repeats = 2;
			}
			else if (wildArea == 9) {
				repeats = 3;
			}

			// Log.Debug(this.logGroup, "Expanding wild area " + wildArea + ", repeats " + repeats);

			

			this.OnNext(this.currentWild, this.wilds[this.currentWild].symbolsRect);
		}
	}

	protected StopAudio(): void
	{
		// then also stop audio
		this.audio.Stop(this.resid.ScopedResourceName("background"));
	}

	public Update() {
		// if (this.currentWild != -1) {
		// 	this.wilds[this.currentWild].Update();
		// }
	}

	public View(): HTMLElement {
		return null;
	}

	private completeCallbaks: ExpandingWildsBulkFinishedCallback[] = [];
	private OnComplete() {
		for (let callback of this.completeCallbaks) {
			callback();
		}
	}

	public AddOnCompleteCallback(callback: ExpandingWildsBulkFinishedCallback) {
		this.completeCallbaks.push(callback);
	}

	private nextWildCallbacks: ExpandingWildsBulkNextWildCallback[] = [];
	private OnNext(wildIndex: number, rect: Rect) {
		for (let callback of this.nextWildCallbacks) {
			callback(wildIndex, rect);
		}
	}

	public AddOnNextCallback(callback: ExpandingWildsBulkNextWildCallback) {
		this.nextWildCallbacks.push(callback);
	}

	public ViewPIXIAPP() : PIXI.Container {
		return this.viewPIXIAPP
	}

	public Destroy(){
		this.wilds.forEach(ele=>{
			ele.Destroy();
		})
	}
}
